import React from 'react';
import { Brain } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ThinkingAnimationProps {
  text?: string;
}

const ThinkingAnimation: React.FC<ThinkingAnimationProps> = ({ 
  text 
}) => {
  const { t } = useTranslation();
  const displayText = text || t('chatbot.thinking');
  
  return (
    <div className="flex items-center space-x-3">
      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gebeya-pink/20 to-gebeya-orange/20 p-1 flex items-center justify-center overflow-hidden">
        <div className="w-full h-full rounded-full bg-white flex items-center justify-center thinking-animation">
          {/* Option 1: Emoji-style brain */}
          <div className="thinking-emoji">
            <Brain 
              className="h-6 w-6 text-gebeya-pink" 
              style={{ 
                filter: "drop-shadow(0 0 2px rgba(255, 20, 147, 0.5))" 
              }} 
            />
          </div>
        </div>
      </div>
      <div className="flex items-center">
        <span className="text-sm text-gray-600 mr-2">{displayText}</span>
        <div className="flex space-x-1">
          <div className="w-2 h-2 rounded-full bg-gebeya-pink animate-bounce opacity-80"></div>
          <div className="w-2 h-2 rounded-full bg-gebeya-pink animate-bounce opacity-80" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-2 h-2 rounded-full bg-gebeya-pink animate-bounce opacity-80" style={{ animationDelay: '0.4s' }}></div>
        </div>
      </div>
    </div>
  );
};

export default ThinkingAnimation; 